export let LiveSiteErrorDisplayedInDispatchModalErrorType = /*#__PURE__*/function (LiveSiteErrorDisplayedInDispatchModalErrorType) {
  LiveSiteErrorDisplayedInDispatchModalErrorType["NO_FULFILLMENTS"] = "no_fulfillments";
  LiveSiteErrorDisplayedInDispatchModalErrorType["NO_ADDRESS"] = "no_address";
  return LiveSiteErrorDisplayedInDispatchModalErrorType;
}({});
//# sourceMappingURL=constants.js.map